import { Link } from 'react-router-dom';
import { ArrowLeft, Smartphone } from 'lucide-react';
import { useSettings } from '@/access/SettingsContext';
import { useIsManager } from '@/access/usePerm';

/**
 * ההקשר לצד אפליקציית העובד במסך רחב. בטלפון אינו קיים.
 *
 * תפקידו אחד: שמי שפתח את המערכת במחשב יבין שהוא רואה אפליקציית
 * טלפון בגודלה, ולא מסך שנשבר. למנהל יש כאן גם הדרך חזרה לקונסולה,
 * כי אם הוא כאן סימן שבחר בכך, והבחירה צריכה להיות הפיכה.
 */
export function DesktopAside() {
  const { brand } = useSettings();
  const isManager = useIsManager();

  return (
    <aside className="hidden max-w-xs lg:grid lg:gap-5">
      {/* בלי לוגו: הוא כבר מופיע ב AppBar שבתוך המסגרת, שני סנטימטר מכאן */}
      <div className="grid gap-2">
        <h1 className="m-0 font-display text-display-l font-semibold text-ink">
          {brand.app_title}
        </h1>
        <p className="m-0 flex items-start gap-2 text-body-sm text-muted">
          <Smartphone size={18} strokeWidth={1.75} aria-hidden="true" className="mt-0.5 shrink-0" />
          <span>
            האפליקציה נבנתה לטלפון, וזה הגודל שלה. אפשר לעבוד כאן, אבל בטלפון היא נוחה
            יותר ושם גם מגיעות ההתראות.
          </span>
        </p>
      </div>

      {isManager && (
        <Link
          to="/admin"
          className="inline-flex min-h-11 w-fit items-center gap-2 rounded-md bg-charcoal px-4 text-body-sm font-medium text-on-charcoal no-underline"
        >
          למערכת הניהול
          <ArrowLeft size={18} strokeWidth={1.75} aria-hidden="true" />
        </Link>
      )}
    </aside>
  );
}
